import auth from './modules/auth'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = () => {
  return new Vuex.Store({
    modules: {
      auth
    }
  })
}
export default store



// WEBPACK FOOTER //
// ./src/store/index.js